// src/components/DiyImageShow/DiyImageShow.jsx
import React, { useEffect, useState } from "react";
import {
    Grid,
    LineShape,
    ArcOrCorner,
    TextShape,
    CurveShape, CircleShape, EllipseShape
} from '../DiyImage/DiyImage.jsx';

const DiyImageShow = ({ savedData, showGrid = true}) => {
    const [shapes, setShapes] = useState(savedData.shapes || []);
    const cellSize = savedData.cellSize || 20;
    const width = savedData.svgWidth || 320;
    const height = savedData.svgHeight || 240;

    useEffect(() => {
        if (savedData) {
            setShapes(savedData.shapes || []);
        }
    }, [savedData]);

    return (
        <div className="diy-container">
            <svg
                className="diy-svg"
                width="100%"
                height="auto"
                viewBox={`0 0 ${width} ${height}`}
            >
                {/* 网格 */}
                <Grid width={width} height={height} cellSize={cellSize} showGrid={showGrid} />

                {/* 已完成图形(线 + 弧/折线 + 文字) */}
                {shapes.map((sh) => {
                    if (sh.type === "line") {
                        return <LineShape key={sh.id} shape={sh} cellSize={cellSize} />;
                    } else if (sh.type === "arc") {
                        return <ArcOrCorner key={sh.id} shape={sh} />;
                    } else if (sh.type === "text") {
                        return <TextShape key={sh.id} shape={sh} />;
                    } else if (sh.type === "curve") {
                        return <CurveShape key={sh.id} shape={sh} />;
                    } else if (sh.type === "circle") {
                        return <CircleShape key={sh.id} shape={sh} />;
                    } else if (sh.type === "ellipse") {
                        return <EllipseShape key={sh.id} shape={sh} />;
                    }
                    return null;
                })}
            </svg>
        </div>
    );
};

export default DiyImageShow;